module.exports = __webpack_public_path__ + "img/mediaPackageCodes.ec75ad5d.svg";